import React from "react";
import PropTypes from "prop-types";
import Image from "@sparefoot/react-commons/Image";
import { Button } from "components/core/Button";
import { Paragraph } from "components/core/Typography";

import Loading from "assets/icons/loading.svg";
import Alert from "assets/icons/alert.svg";

import "./ModalReservation.scss";

const LoadingModal = () => (
	<div className="modal-loading">
		<Image
			alt="Loading"
			className="modal-image"
			src={Loading}
		/>
		<Paragraph
			size="large"
			weight="bold"
		>
			Reservation Processing
		</Paragraph>
		<Paragraph
			className="modal-center-text"
			size="standard"
			weight="regular"
		>
			Please wait while our systems process your reservation request.
		</Paragraph>
	</div>
);

function ModalReservation({
	isLoadingModal,
	successReservation,
	onClose,
	otherFacilities,
	errorReservationMessages
}) {
	if (!isLoadingModal && successReservation) {
		onClose();
	}

	return (
		<div className="modal-reservation">
			<div className="modal-reservation-container">
				{isLoadingModal || successReservation ? (
					<LoadingModal />
				) : (
					<div className="modal-reservation-fail">
						<div>
							<Paragraph
								className="modal-button-cancel"
								weight="standard"
								onClick={onClose}
								last
							>
								&times;
							</Paragraph>
							<Image
								className="modal-image"
								alt="Alert icon"
								src={Alert}
							/>
							<Paragraph
								size="large"
								weight="bold"
								last
							>
								Something Went Wrong
							</Paragraph>
							<Paragraph
								className="modal-center-text"
								size="standard"
								weight="regular"
								last
							>
								{errorReservationMessages ||
									"Sorry, that unit is no longer available. Please select another unit"}
							</Paragraph>
						</div>
						<div>
							<Button
								onClick={onClose}
								theme="primary"
							>
								View Other Unit Options
							</Button>
							<Button
								className="modal-button"
								onClick={otherFacilities}
								theme="text"
							>
								{" "}
							</Button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

ModalReservation.propTypes = {
	isLoadingModal: PropTypes.bool,
	successReservation: PropTypes.bool,
	onClose: PropTypes.func,
	otherFacilities: PropTypes.func,
	errorReservationMessages: PropTypes.string
};

export default ModalReservation;
